export default __webpack_public_path__ + "static/media/NW0120.34I-35462_-20498_0.380b9d63.jpg";